import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	open: false,
	isAnimating: false,
	menuTransition: false,
	isCarouselVisible: false,
	selectedItem: {},
	selectedSubItem: null,
	isMenuTransparent: false,
};

export const menuSlice = createSlice({
	name: 'menu',
	initialState,
	reducers: {
		setIsMenuOpen: (state, payload) => {
			state.open = payload.payload;
		},
		setIsAnimating: (state, payload) => {
			state.isAnimating = payload.payload;
		},
		setMenuTransition: (state, payload) => {
			state.menuTransition = payload.payload;
		},
		setIsCarouselVisible: (state, payload) => {
			state.isCarouselVisible = payload.payload;
		},
		setSelectedItem: (state, payload) => {
			state.selectedItem = payload.payload;
		},
		setSelectedSubItem: (state, payload) => {
			state.selectedSubItem = payload.payload;
		},
		setIsMenuTransparent: (state, payload) => {
			state.isMenuTransparent = payload.payload;
		},
	},
});

export const {
	setIsMenuTransparent,
	setIsMenuOpen,
	setIsAnimating,
	setMenuTransition,
	setSelectedSubItem,
	setSelectedItem,
	setIsCarouselVisible,
} = menuSlice.actions;

export default menuSlice.reducer;
